type AppRoute = {
  path: string;
  crumb?: string;
};

const route = (path: string, crumb?: string): AppRoute => ({
  path,
  crumb,
});

const basePaths = {
  home: route('/', 'Homepage'),
  employeeDashboard: route('/employee-dashboard', 'Dashboard'),
  notifications: route('/notifications', 'Notifications'),
  profile: route('/profile', 'My profile'),
  changePassword: route('/change-password', 'Change password'),
  employees: route('/employees'),
  employeeProfile: route('/employees/:employeeId', 'Employee name'),
  adminProfile: route('/admins/:adminId', 'Admin name'),
  gifting: route('/gifting', 'Gifting'),
  rewardEmployees: route('/gifting/reward-employees', 'Gift employees'),
  reports: route('/reports', 'Reports'),
};

export const footerPaths = {
  privacyPolicy: route('/privacy-policy', 'Privacy Policy'),
  termsAndConditions: route('/terms-and-conditions', 'Terms & Conditions'),
  sitemap: route('/sitemap', 'Sitemap'),
};

export const rewardAndRecognitionPaths = {
  rewardAndRecognitionOverview: route('/reward-and-recognition', 'Overview'),
  myPrides: route('/reward-and-recognition/my-prides', 'My Prides'),
  theRoar: route('/reward-and-recognition/the-roar', 'The Roar'),
  createRecognition: route('/reward-and-recognition/recognise', 'Recognise someone'),
  approvals: route('/reward-and-recognition/approvals', 'Approvals'),
  recognitionAudit: route('/reward-and-recognition/audit', 'Audit'),
};

export const benefitsPaths = {
  benefitsOverview: route('/benefits', 'Overview'),
  benefitsManager: route('/benefits/manager', 'Benefits Manager'),
  addBenefit: route('/benefits/new', 'Add new benefit'),
  editBenefit: route('/benefits/:benefitId/edit', 'Edit benefit'),
  benefitDetails: route('/benefits/details', 'Benefit Details'),
};

export const walletAndPotsPaths = {
  walletsAndPots: route('/wallets-and-pots', 'Company Wallet'),
  pot: route('/wallets-and-pots/:potId', 'Pot'),
};

export const unauthenticatedPaths = {
  authentication: '/authentication',
  onboardingGifting: '/onboarding/gifting',
};

export const authenticatedPaths = {
  ...basePaths,

  importEmployees: route('/import-employees', 'Upload data'),
  employees: route(basePaths.employees.path, 'Employees'),
  admins: route('/admins', 'Admins'),

  ...footerPaths,
  ...rewardAndRecognitionPaths,
  ...benefitsPaths,
  ...walletAndPotsPaths,
};

export const authenticatedGiftingPaths = {
  ...basePaths,

  manageEmployees: route(basePaths.employees.path, 'Manage people'),
  importEmployees: route('/employees/import', 'Bulk upload'),
  manageAdmins: route('/admins', 'Manage admins'),

  ...footerPaths,
  ...rewardAndRecognitionPaths,
  ...benefitsPaths,
  ...walletAndPotsPaths,
};
